<template>
  <rect
    v-if="selectionData.id !== null && selectionData.id !== undefined"
    v-bind="attributes"
    style="fill: none; stroke: hsl(205, 100%, 45%); stroke-width: 2"
    tabindex="-1"
    class="selection"
  />
</template>

<script>
export default {
  computed: {
    selectionData() {
      return this.$store.state.customFlow.selection;
    },
    attributes() {
      const minPoint = this.selectionData.minPoint;
      const maxPoint = this.selectionData.maxPoint;

      return {
        x: minPoint[0] - 4,
        y: minPoint[1] - 4,
        width: Math.abs(maxPoint[0] - minPoint[0]) + 8,
        height: Math.abs(maxPoint[1] - minPoint[1]) + 8,
      };
    },
  },
};
</script>

<style lang="less" scoped>
.selection {
  transition: x 0.3s ease;
}
</style>
